import React from 'react';
import "./NotFound.css"
const NotFound = () => {
    return (
        <div >
            <img className="image" src="https://drudesk.com/sites/default/files/2018-02/404-error-page-not-found.jpg" alt="" />
        </div>
    );
};

export default NotFound;